var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-container"},[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):(_vm.isError)?_c('no-data'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }